<template>
  <el-row>
    <h6 style="text-align: left; margin-top: 20px">收入明细: </h6>
    <el-table
      :data="incomes.slice((incomesForm.page - 1) * incomesForm.pageSize, incomesForm.page * incomesForm.pageSize)"
      border
      style="width: 100%">
      <el-table-column
        prop="payOrderId"
        label="支付订单ID"
        width="220">
      </el-table-column>
      <el-table-column
        prop="originalAmount"
        label="原始订单金额">
        <template slot-scope="scope">
          {{ scope.row.originalAmount }} 分
        </template>
      </el-table-column>
      <el-table-column
        prop="shareRatio"
        sortable
        label="提成比例">
        <template slot-scope="scope">
          {{ scope.row.shareRatio }}%
        </template>
      </el-table-column>
      <el-table-column
        prop="shareMoney"
        sortable
        label="提成金额">
        <template slot-scope="scope">
          {{ scope.row.shareMoney }} 分
        </template>
      </el-table-column>
      <el-table-column
        prop="comment"
        label="备注">
      </el-table-column>

      <el-table-column
        prop="dateStr"
        sortable
        label="发生时间">
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      v-if="incomesTotalElements > 0"
      background
      layout="prev, pager, next"
      :current-page.sync="incomesForm.page"
      :page-size="incomesForm.pageSize"
      :total="incomesTotalElements">
    </el-pagination>

    <h6 style="text-align: left; margin-top: 20px">提现记录: </h6>
    <el-table
      :data="cashOutRecords.slice((cashOutForm.page - 1) * cashOutForm.pageSize, cashOutForm.page * cashOutForm.pageSize)"
      border
      style="width: 100%">
      <el-table-column
        prop="cashOutHistoryId"
        label="编号"
        width="80">
      </el-table-column>
      <el-table-column
        prop="settleAmount"
        label="提现金额">
        <template slot-scope="scope">
          {{ scope.row.settleAmount }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="leftAmount"
        label="可用余额">
        <template slot-scope="scope">
          {{ scope.row.leftAmount }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="actuallyGet"
        label="实际到手">
        <template slot-scope="scope">
          {{ scope.row.actuallyGet }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="createAt"
        sortable
        label="发生时间">
      </el-table-column>
      <el-table-column
        prop="statusStr"
        sortable
        label="状态">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.status == 5 ? 'success' : (scope.row.status == 3 ? 'danger' : 'info') ">
            {{ scope.row.statusStr }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      v-if="cashOutTotalElements > 0"
      background
      layout="prev, pager, next"
      :current-page.sync="cashOutForm.page"
      :page-size="cashOutForm.pageSize"
      :total="cashOutTotalElements">
    </el-pagination>
  </el-row>
</template>

<script>
export default {
  name: "BalanceDetails",
  props: {
    incomes: Array,
    cashOutRecords: Array,
    cashOutTotalElements: Number,
    incomesTotalElements: Number
  },
  data() {
    return {
      incomesForm: {
        page: 1,
        pageSize: 10
      },
      cashOutForm: {
        page: 1,
        pageSize: 10
      },
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/users/balance/BalanceDetails.vue